import $ from 'jquery';
//import utils from '../Libraries/Utils';
//console.log('is touch:', utils.isTouchDevice());

$('.nav-toggle').on('click', function () {
    var toggleActiveClass = 'nav-toggle--active';
    var navActiveClass = 'nav--visible';
    if ($(this).hasClass(toggleActiveClass)) {
        $(this).removeClass(toggleActiveClass);
        $('.nav').removeClass(navActiveClass);
    } else {
        $(this).addClass(toggleActiveClass);
        $('.nav').addClass(navActiveClass);
    }
});


$('.nav__toggle').on('click', function () {
    $(this).siblings('.nav__list').toggleClass('nav__list--visible');
    $(this).toggleClass('nav__toggle--open');
})
